import { render } from "./ToolButton.vue?vue&type=template&id=afecc6f2&scoped=true"
import script from "./ToolButton.vue?vue&type=script&lang=js"
export * from "./ToolButton.vue?vue&type=script&lang=js"

import "./ToolButton.vue?vue&type=style&index=0&id=afecc6f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afecc6f2"]])

export default __exports__